import { RoleInputFilter } from "domain/models/role-input-filter";
import Spinner from "presentation/components/Shared/Spinner";
import usePermissionCheck from "presentation/hooks/use-check-permissions";
import { useRoleByFilter } from "presentation/hooks/use-query-role";
import { useAuthStore } from "presentation/stores/use-auth-store";
import { TabPanel, TabView } from "primereact/tabview";
import React, { useEffect } from "react";
import FunctionHeader from "../../components/Header/FunctionHeader";
import InvoiceGrid from "presentation/components/Invoice/InvoiceGrid";
import InvoiceAdmin from "presentation/components/Invoice/InvoiceAdmin";

const InvoicePage = ({ children }: { children?: React.ReactNode }) => {
  const rolesAllowedAdmin = ["CEO", "Finanças", "Admin"];
  const rolesAllowedUpload = ["CPS"]
  const [isAdminEnabled, setIsAdminEnabled] = React.useState(false);
  const [isUploadEnabled, setIsUploadEnabled] = React.useState(false);
  const { isLoading } = usePermissionCheck({ requiredFunction: "invoices" });
  const { userPermissions } = useAuthStore();
  const { data: rolesData } = useRoleByFilter({
    limit: 100,
  } as RoleInputFilter);

  useEffect(() => {
    const rolesAdminSelected = rolesData?.data?.filter((role) =>
      rolesAllowedAdmin.includes(role.name)
    );
    const adminPermissions = userPermissions?.filter((permission) =>
      rolesAdminSelected?.some((role) => role.id === permission.roleId)
    );
    const hasAdminPermission = adminPermissions && adminPermissions.length > 0;
    setIsAdminEnabled(hasAdminPermission ?? false);

    // ------------------------------------------

    const rolesUploadSelected = rolesData?.data?.filter((role) =>
      rolesAllowedUpload.includes(role.name)
    );
    const uploadPermissions = userPermissions?.filter((permission) =>
      rolesUploadSelected?.some((role) => role.id === permission.roleId)
    );
    const hasUploadPermission = uploadPermissions && uploadPermissions.length > 0;
    setIsUploadEnabled(hasUploadPermission ?? false);

  }, [rolesData]);

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <div>
      <FunctionHeader title="Faturas" />
      <TabView>
        {isUploadEnabled && (
          <TabPanel header="Faturas" leftIcon="pi pi-receipt mr-2">
            <InvoiceGrid hideAddInvoice={false}/>
          </TabPanel>
        )}
        {isAdminEnabled && (
          <TabPanel header="Administração" leftIcon="pi pi-cog mr-2">
            <InvoiceAdmin />
          </TabPanel>
        )}
      </TabView>
    </div>
  );
};

export default InvoicePage;
